export const acceptedFileTypes = {
    images: ".png,.jpg,.jpeg,.gif,",
    documents: ".tiff,.tif,.png,.jpg,.jpeg,.gif,.pdf",
};
